<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới Mẫu thiết kế</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-form-item prop="image" label="Ảnh Mẫu thiết kế">
              <el-upload
                class="course-uploader"
                :action="upload.url"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="modelData.image_path" :src="modelData.image_path" class="course">
                <i v-else class="el-icon-plus course-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh Mẫu thiết kế có dung lượng tối đa tải lên là 2Mb
                </div>
              </el-upload>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Tên Mẫu thiết kế" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
                </el-form-item>
                <el-form-item prop="category_id" label="Danh mục mẫu thiết kế" class="form-item">
                  <el-select v-model="modelData.category_id" filterable clearable placeholder="Danh mục mẫu thiết kế" class="input-select">
                    <el-option
                      v-for="item in lists.listCategoryBlogs"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="description" label="Mô tả ngắn" class="form-item">
                  <el-input v-model="modelData.description" :rows="5" type="textarea" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="search" label="Search" class="form-item">
                  <el-input v-model="modelData.search" :rows="5" type="textarea" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="priority" label="Độ ưu tiên" class="form-item">
                  <el-input v-model="modelData.priority" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="link" label="Link" class="form-item">
                  <el-input v-model="modelData.link" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="link_more" label="Link thêm" class="form-item">
                  <el-input v-model="modelData.link_more" :rows="5" type="textarea" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="alt" label="Alt" class="form-item">
                  <el-input v-model="modelData.alt" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="view" label="View" class="form-item">
                  <el-input v-model="modelData.view" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="content" label="Nội dung Mẫu thiết kế">
              <tinymce
                id="d1"
                v-model="modelData.content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '500px',  images_upload_handler: handleImageAdded, language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import ls from 'local-storage'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'ClipCreate',
  metaInfo () {
    return {
      title: 'Mẫu thiết kế | Thêm'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: 'Mẫu ',
        image: '',
        priority: '0',
        description: '',
        alt: '',
        view: '300',
        link_more: '',
        content: '',
        status: true
      },
      lists: {
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listTeacher: [
          {key: 0, value: 'Chọn giảng viên'}
        ],
        listUniversity: [
          {key: 0, value: 'Không thuộc trường nào'},
          {key: 1, value: 'Trường Học Viện Ngân Hàng'},
          {key: 2, value: 'Trường Kinh Tế Quốc Dân'}
        ],
        listCategoryBlogs: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ]
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'items/upload',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên mẫu thiết kế' },
          { min: 2, max: 191, message: 'Tên mẫu thiết kế có chiều dài từ 2 tới 191 kí tự' }
        ],
        price: [
          { required: true, message: 'Vui lòng nhập giá mẫu thiết kế' },
          { type: 'number', message: 'Giá mẫu thiết kế phải là kiểu số' }
        ],
        price_brick: [
          { required: true, message: 'Vui lòng nhập giá mẫu thiết kế bị gạch' },
          { type: 'number', message: 'Giá mẫu thiết kế bị gạch phải là kiểu số' }
        ],
        category_course_id: [
          { required: true, message: 'Vui lòng nhập lĩnh vực mẫu thiết kế' }
        ],
        teacher_id: [
          { required: true, message: 'Vui lòng nhập giảng viên của mẫu thiết kế' }
        ],
        image: [
          { required: true, message: 'Vui lòng upload ảnh của mẫu thiết kế' }
        ],
        date_use: [
          { required: true, message: 'Vui lòng nhập số ngày sử dụng của mẫu thiết kế' },
          { type: 'number', message: 'Số ngày sử dụng của mẫu thiết kế phải là kiểu số' }
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.configBreadcrumb()
    this.configUpload()
    this.fetchListCategoryBlogs()
    // this.fetchListCategoryCourse()
    // this.fetchListUniversitiy()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('items/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path_sm)
      } else {
        return false
      }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'items-index', text: 'Mẫu thiết kế' },
        { name: 'items-create', text: 'Thêm mới' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'items-index'})
    },
    // Fetch dữ liệu về lĩnh vực tin tức
    fetchListCategoryBlogs () {
      axios.get('category-items/get-recursive-category-items').then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryBlogs = response.data.categories
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về lĩnh vực mẫu thiết kế
    fetchListCategoryCourse () {
      axios.get('category-courses', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về giảng viên
    fetchListTeacher () {
      axios.get('users', {params: {'status': 1, 'system_manager': 0, 'user_type': 2}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về trường đại học
    fetchListUniversitiy () {
      axios.get('universities', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listUniversity = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('items', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm tài khoản thành công',
              type: 'success'
            })
            this.$router.push({name: 'items-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh mẫu thiết kế có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.image = response.data.name
        this.modelData.image_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  },
  watch: {
    'modelData.name': function () {
      this.modelData.alt = this.modelData.name + ' do Nga Linh thiết kế'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.course {
  width: 280px;
  height: 200px;
  display: block;
}
</style>

<style type="text/css">
.course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/items/Create.vue